//@ts-nocheck
/**
 * AUTO_GENERATED Do not change this file directly, use config.ts file instead
 *
 * @version 6
 */

import type { AxiosRequestConfig } from "axios";
import type { SwaggerResponse } from "./config";
import { Http } from "./httpRequest";
//@ts-ignore
import qs from "qs";
import type {
  WelfareController_getFullWelfareQueryParams,
  WelfareController_allImagesQueryParams,
  LiceController_GetTemperatureQueryParams,
  LiceController_Last200LiceQueryParams,
  LiceController_DailyLiceQueryParams,
  LiceController_WeeklyLiceQueryParams,
  LiceController_LiceParityQueryParams,
  BiomassController_GetFeedingConversionRateQueryParams,
  ClientController_OverviewQueryParams,
  ClientController_AllLiceWeeklyReportQueryParams,
  ClientController_AllLiceDailyReportQueryParams,
  ClientController_AllLiceDailyReportsQueryParams,
  ClientController_RangeLiceReportQueryParams,
  ClientController_RangeLiceReportsQueryParams,
  LocationController_MarkHistoricalQueryParams,
  CageController_ContextQueryParams,
  CageController_OverviewQueryParams,
  CageController_getWelfareOverviewQueryParams,
  CageController_getHealthOverviewQueryParams,
  CageController_getWeightDistributionsQueryParams,
  CageImageController_GetImageListQueryParams,
  BioscopeImageController_GetImageListQueryParams,
  BehaviorController_getOverviewQueryParams,
  BehaviorController_getSwimSpeedQueryParams,
  BehaviorController_getRespirationQueryParams,
  BehaviorController_getTiltQueryParams,
  CompareController_getLocationCompareQueryParams,
  LocationDepthSeriesController_getLocationDepthSeriesQueryParams,
  CageDepthSeriesController_getCageDepthSeriesQueryParams,
  HealthController_getQualityQueryParams,
  HealthController_getHealthDataQueryParams,
  SmoltReportController_createReportQueryParams,
  TasksController_getTasksQueryParams,
  ActivityLogController_getActivityLogQueryParams,
  AuditLogController_listQueryParams,
  AuditLogController_exportQueryParams,
  AuditLogOptionsController_scopesQueryParams,
  FeedingDashboardController_getOverviewQueryParams,
  FishGroupsController_getEventsQueryParams,
  StockingCyclesController_assignFishGroupsQueryParams,
  LocationFishGroupsController_timelineQueryParams,
  NavigationController_searchByNameQueryParams,
  Alert,
  CreateNewContractInput,
  ContractRecord,
  Cage,
  LicenseInfo,
  Contract,
  CreateNewContractLicenseInput,
  ContractLicenseRecord,
  CreateNewLicenseForClientInput,
  ClientLicenseResponse,
  LocationsLicenseOverview,
  ClientWithLocations,
  LicenseResponse,
  LicenseUser,
  ClientLicenseUser,
  UpdateClientLicenseInput,
  BwWelfareResponse,
  FullSizeImage,
  TemperatureResult,
  Last3DaysResponseDto,
  DailyLiceCountResponseDto,
  WeeklyLiceCountResponseDto,
  MoveBioscopeQueryParams,
  FeedingConversionRateResult,
  UserProfileDto,
  Me,
  UpdateUserProfileDto,
  ResetPasswordRequest,
  ResetPassword,
  LoginForm,
  InviteForm,
  SetUserClientAccessForm,
  RegisterUserForm,
  DeleteUserResponse,
  LocationTypeInfo,
  ClientWithLocationsInfo,
  VideoStreamSettingsDto,
  BioscopeStreamSettingsRowDto,
  UpdateVideoStreamSettingsInput,
  ClientInfo,
  ClientSummaryDto,
  ClientOverviewResponseDto,
  AllWeeklyReportResponseDto,
  DailyReportResult,
  DailyClientReportResult,
  RangeReportResult,
  RangeClientReportResult,
  GetApiUsersResponse,
  CreateApiUserInput,
  CreateNewClientInput,
  CreatedClientDto,
  UpdateClientDto,
  LocationBioscopeStatusDto,
  LocationWeightStatusDto,
  UpdateLocation,
  LocationResponseDto,
  NewLocation,
  CageHistoricalDto,
  CageListItemDto,
  CageStatus,
  CageContextResponseDto,
  BiomassOverviewResponseDto,
  CageWelfareOverviewResponseDto,
  CageHealthOverviewResponseDto,
  GetWeightDistributionsResponse,
  CreateCagesDto,
  UpdateCageDto,
  UpdateCageResponse,
  FishType,
  LiceType,
  GetCageTypesResponse,
  ActiveBioscope,
  CreateBioscope,
  UpdateBioscope,
  AcknowledgeAlert,
  AlertAcknowledgement,
  UnacknowledgeAlert,
  ReportList,
  ReportDetail,
  NewReport,
  Client,
  BioscopeDetail,
  SanityContentResponse,
  BioscopeRestart,
  BioscopeRouterRestart,
  DaysWithImages,
  CageImage,
  BioscopeImage,
  SmsInput,
  ImageFeedbackDto,
  EmqxJwtPayloadDto,
  OverviewResponseDto,
  SwimSpeedResponseDto,
  RespirationResponseDto,
  TiltResponseDto,
  LocationCompareResponseDto,
  DepthSeriesResponseDto,
  HealthQualityResponseDto,
  HealthOverviewDto,
  SmoltReportListResponseDto,
  SmoltReportDetailResponseDto,
  CreateSmoltReportDto,
  TaskResponseDto,
  TaskListResponseDto,
  CompleteTaskDto,
  IgnoreTaskDto,
  ActivityLogResponseDto,
  CreateManualActivityDto,
  AuditLogPageDto,
  AuditLogFacetsDto,
  AuditScopeOptionDto,
  PenOverviewResponseDto,
  FeedingDashboardConfigDto,
  FeedingDashboardOverviewDto,
  UpdateFeedingDashboardConfigDto,
  UpdateFeedingCageConfigDto,
  CreateFishGroupRequest,
  FishGroupDto,
  FishGroupOperationRequest,
  RelocateFishGroupRequest,
  CloseFishGroupRequest,
  DiscardFishGroupRequest,
  RecordFishGroupEventRequest,
  FishGroupTransferEventDto,
  UpdateFishGroupMetadataRequest,
  RevertPreviewDto,
  RevertFishGroupOperationRequest,
  ClientFishGroupsOverviewDto,
  FishGroupDetailDto,
  FishGroupLineageDto,
  CageFishGroupHistoryItemDto,
  FishGroupLocationHistoryItemDto,
  StockingCycleDto,
  StockingCycleListDto,
  CreateStockingCycleRequest,
  UpdateStockingCycleRequest,
  AssignFishGroupsToCycleRequest,
  AssignFishGroupsToCycleResponseDto,
  FishGroupTimelineDto,
  OccupiedPensDto,
  SiteRelocateFishGroupRequest,
  SiteDelousingRequest,
  StockingLineageDto,
  SiteStockingAssignmentRequest,
  UnassignFishGroupsFromCycleResponseDto,
  CageActiveFishGroupResponseDto,
  UpdateCageActiveFishGroupRequest,
  NavigationResolveResponseDto,
  ProviderSchemaDto,
  LocationProviderConfigDto,
  SaveProviderConfigRequestDto,
  TestProviderConfigRequestDto,
  TestProviderConfigResultDto,
  ClarifyCatalogRequestDto,
  ClarifyCatalogDto,
  FetchHistoryRequestDto,
  FetchHistoryResultDto,
  ProviderAccountDto,
  SaveProviderAccountRequestDto,
  ClientIntegrationRowDto,
  LocationStreamStatusDto,
} from "./types";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const __DEV__ = process.env.NODE_ENV !== "production";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function overrideConfig(
  config?: AxiosRequestConfig,
  configOverride?: AxiosRequestConfig,
): AxiosRequestConfig {
  return {
    ...config,
    ...configOverride,
    headers: {
      ...config?.headers,
      ...configOverride?.headers,
    },
  };
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function template(path: string, obj: { [x: string]: any } = {}) {
  Object.keys(obj).forEach((key) => {
    const re = new RegExp(`{${key}}`, "i");
    path = path.replace(re, obj[key]);
  });

  return path;
}

function isFormData(obj: any) {
  // This checks for the append method which should exist on FormData instances
  return (
    (typeof obj === "object" &&
      typeof obj.append === "function" &&
      obj[Symbol.toStringTag] === undefined) ||
    obj[Symbol.toStringTag] === "FormData"
  );
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function objToForm(requestBody: object) {
  if (isFormData(requestBody)) {
    return requestBody;
  }
  const formData = new FormData();

  Object.entries(requestBody).forEach(([key, value]) => {
    value && formData.append(key, value);
  });

  return formData;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function objToUrlencoded(requestBody: object) {
  return qs.stringify(requestBody);
}

/**
 *
 * Acknowledge an alert
 */
export const AcknowledgedAlertsController_acknowledgeAlert = (
  requestBody: AcknowledgeAlert,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<AlertAcknowledgement>> => {
  return Http.postRequest(
    AcknowledgedAlertsController_acknowledgeAlert.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
AcknowledgedAlertsController_acknowledgeAlert.key = "/api/v2/alerts/ack";

/**
 *
 * Get all acknowledgements
 */
export const AcknowledgedAlertsController_getAcknowledgements = (
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<AlertAcknowledgement[]>> => {
  return Http.getRequest(
    AcknowledgedAlertsController_getAcknowledgements.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
AcknowledgedAlertsController_getAcknowledgements.key =
  "/api/v2/alerts/acknowledgements";

/**
 *
 * Unacknowledge an alert
 */
export const AcknowledgedAlertsController_unacknowledgeAlert = (
  requestBody: UnacknowledgeAlert,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<AlertAcknowledgement>> => {
  return Http.postRequest(
    AcknowledgedAlertsController_unacknowledgeAlert.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
AcknowledgedAlertsController_unacknowledgeAlert.key = "/api/v2/alerts/unack";

export const ActivityLogController_createManualActivity = (
  locationId: number,
  requestBody: CreateManualActivityDto,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(ActivityLogController_createManualActivity.key, { locationId }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ActivityLogController_createManualActivity.key =
  "/api/v2/operational-dashboard/{locationId}/activity-log";

export const ActivityLogController_getActivityLog = (
  locationId: number,
  queryParams?: ActivityLogController_getActivityLogQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ActivityLogResponseDto>> => {
  return Http.getRequest(
    template(ActivityLogController_getActivityLog.key, { locationId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ActivityLogController_getActivityLog.key =
  "/api/v2/operational-dashboard/{locationId}/activity-log";

export const AlertsController_allAlerts = (
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<Alert[]>> => {
  return Http.getRequest(
    AlertsController_allAlerts.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
AlertsController_allAlerts.key = "/api/v2/alerts/unsolved";

/**
 *
 * Export the matching audit log entries as CSV
 */
export const AuditLogController_export = (
  queryParams?: AuditLogController_exportQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<string>> => {
  return Http.getRequest(
    AuditLogController_export.key,
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT2, configOverride),
  );
};

/** Key is end point string without base url */
AuditLogController_export.key = "/api/v2/audit-log/export";

/**
 *
 * List audit log entries, newest first, paged by id
 */
export const AuditLogController_list = (
  queryParams?: AuditLogController_listQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<AuditLogPageDto>> => {
  return Http.getRequest(
    AuditLogController_list.key,
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
AuditLogController_list.key = "/api/v2/audit-log";

/**
 *
 * The actions and target types present in the audit log
 */
export const AuditLogOptionsController_facets = (
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<AuditLogFacetsDto>> => {
  return Http.getRequest(
    AuditLogOptionsController_facets.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
AuditLogOptionsController_facets.key = "/api/v2/audit-log/facets";

/**
 *
 * Clients, sites and pens to filter the audit log by, found by name or id
 */
export const AuditLogOptionsController_scopes = (
  queryParams: AuditLogOptionsController_scopesQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<AuditScopeOptionDto[]>> => {
  return Http.getRequest(
    AuditLogOptionsController_scopes.key,
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
AuditLogOptionsController_scopes.key = "/api/v2/audit-log/scopes";

/**
 *
 * Get behavior overview for a cage
 */
export const BehaviorController_getOverview = (
  /**
   *
   * Cage ID
   */
  cageId: number,
  queryParams?: BehaviorController_getOverviewQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<OverviewResponseDto>> => {
  return Http.getRequest(
    template(BehaviorController_getOverview.key, { cageId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
BehaviorController_getOverview.key = "/api/v2/behavior/{cageId}/overview";

/**
 *
 * Get respiration data for a cage
 */
export const BehaviorController_getRespiration = (
  /**
   *
   * Cage ID
   */
  cageId: number,
  queryParams?: BehaviorController_getRespirationQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<RespirationResponseDto>> => {
  return Http.getRequest(
    template(BehaviorController_getRespiration.key, { cageId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
BehaviorController_getRespiration.key = "/api/v2/behavior/{cageId}/respiration";

/**
 *
 * Get swim speed data for a cage
 */
export const BehaviorController_getSwimSpeed = (
  /**
   *
   * Cage ID
   */
  cageId: number,
  queryParams?: BehaviorController_getSwimSpeedQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<SwimSpeedResponseDto>> => {
  return Http.getRequest(
    template(BehaviorController_getSwimSpeed.key, { cageId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
BehaviorController_getSwimSpeed.key = "/api/v2/behavior/{cageId}/swimspeed";

/**
 *
 * Get tilt data for a cage
 */
export const BehaviorController_getTilt = (
  /**
   *
   * Cage ID
   */
  cageId: number,
  queryParams?: BehaviorController_getTiltQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<TiltResponseDto>> => {
  return Http.getRequest(
    template(BehaviorController_getTilt.key, { cageId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
BehaviorController_getTilt.key = "/api/v2/behavior/{cageId}/tilt";

export const BiomassController_GetFeedingConversionRate = (
  cageId: number,
  queryParams: BiomassController_GetFeedingConversionRateQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<FeedingConversionRateResult>> => {
  return Http.getRequest(
    template(BiomassController_GetFeedingConversionRate.key, { cageId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
BiomassController_GetFeedingConversionRate.key =
  "/api/v2/Biomass/{cageId}/feedingConversionRate";

export const BioscopeController_ActiveBioscopes = (
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ActiveBioscope[]>> => {
  return Http.getRequest(
    BioscopeController_ActiveBioscopes.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
BioscopeController_ActiveBioscopes.key = "/api/v2/bioscope/active";

export const BioscopeController_ActiveBioscopesForClient = (
  clientId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ActiveBioscope[]>> => {
  return Http.getRequest(
    template(BioscopeController_ActiveBioscopesForClient.key, { clientId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
BioscopeController_ActiveBioscopesForClient.key =
  "/api/v2/bioscope/active/{clientId}";

export const BioscopeController_CreateApiKey = (
  bioscopeId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(BioscopeController_CreateApiKey.key, { bioscopeId }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
BioscopeController_CreateApiKey.key = "/api/v2/bioscope/{bioscopeId}/apikey";

export const BioscopeController_CreateBioscope = (
  requestBody: CreateBioscope,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    BioscopeController_CreateBioscope.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
BioscopeController_CreateBioscope.key = "/api/v2/bioscope/create";

export const BioscopeController_DeleteBioscope = (
  bioscopeId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(BioscopeController_DeleteBioscope.key, { bioscopeId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
BioscopeController_DeleteBioscope.key = "/api/v2/bioscope/{bioscopeId}";

export const BioscopeController_UpdateBioscope = (
  bioscopeId: number,
  requestBody: UpdateBioscope,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(BioscopeController_UpdateBioscope.key, { bioscopeId }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
BioscopeController_UpdateBioscope.key = "/api/v2/bioscope/{bioscopeId}";

export const BioscopeDetailController_BioscopeDetailNew = (
  bioscopeId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<BioscopeDetail>> => {
  return Http.getRequest(
    template(BioscopeDetailController_BioscopeDetailNew.key, { bioscopeId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
BioscopeDetailController_BioscopeDetailNew.key =
  "/api/v2/bioscope-api/bioscopeDetail/{bioscopeId}/BioscopeDetail";

/**
 *
 * Days that have bioscope inspection images for a device
 */
export const BioscopeImageController_GetDaysWithImages = (
  bioscopeId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<DaysWithImages[]>> => {
  return Http.getRequest(
    template(BioscopeImageController_GetDaysWithImages.key, { bioscopeId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
BioscopeImageController_GetDaysWithImages.key =
  "/api/v2/bioscope/{bioscopeId}/images/days";

/**
 *
 * Bioscope inspection images for a single day (defaults to latest)
 */
export const BioscopeImageController_GetImageList = (
  bioscopeId: number,
  queryParams?: BioscopeImageController_GetImageListQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<BioscopeImage[]>> => {
  return Http.getRequest(
    template(BioscopeImageController_GetImageList.key, { bioscopeId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
BioscopeImageController_GetImageList.key =
  "/api/v2/bioscope/{bioscopeId}/images";

export const BioscopeImageController_Image = (
  bioscopeId: number,
  id: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    template(BioscopeImageController_Image.key, { bioscopeId, id }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
BioscopeImageController_Image.key = "/api/v2/bioscope/{bioscopeId}/images/{id}";

export const BioscopeRestartController_BioscopeRestarts = (
  bioscopeId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<BioscopeRestart[]>> => {
  return Http.getRequest(
    template(BioscopeRestartController_BioscopeRestarts.key, { bioscopeId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
BioscopeRestartController_BioscopeRestarts.key =
  "/api/v2/bioscope/{bioscopeId}/restarts";

export const BioscopeRestartController_BioscopeRouterRestarts = (
  bioscopeId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<BioscopeRouterRestart[]>> => {
  return Http.getRequest(
    template(BioscopeRestartController_BioscopeRouterRestarts.key, {
      bioscopeId,
    }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
BioscopeRestartController_BioscopeRouterRestarts.key =
  "/api/v2/bioscope/{bioscopeId}/routerRestarts";

export const BioscopeRestartController_RestartBioscope = (
  bioscopeId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(BioscopeRestartController_RestartBioscope.key, { bioscopeId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
BioscopeRestartController_RestartBioscope.key =
  "/api/v2/bioscope/{bioscopeId}/restartBioscope";

export const BioscopeRestartController_RestartRouter = (
  bioscopeId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(BioscopeRestartController_RestartRouter.key, { bioscopeId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
BioscopeRestartController_RestartRouter.key =
  "/api/v2/bioscope/{bioscopeId}/restartRouter";

/**
 *
 * The active fish group in the cage, or null when it is empty
 */
export const CageActiveFishGroupController_getActiveFishGroup = (
  cageId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<CageActiveFishGroupResponseDto>> => {
  return Http.getRequest(
    template(CageActiveFishGroupController_getActiveFishGroup.key, { cageId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
CageActiveFishGroupController_getActiveFishGroup.key =
  "/api/v2/cage/{cageId}/active-fish-group";

/**
 *
 * Correct the name or initial population size of the cage's active fish group. Journalled as a metadata_updated event with the reason, as the fish-group metadata endpoint does.
 */
export const CageActiveFishGroupController_updateActiveFishGroup = (
  cageId: number,
  requestBody: UpdateCageActiveFishGroupRequest,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<CageActiveFishGroupResponseDto>> => {
  return Http.patchRequest(
    template(CageActiveFishGroupController_updateActiveFishGroup.key, {
      cageId,
    }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
CageActiveFishGroupController_updateActiveFishGroup.key =
  "/api/v2/cage/{cageId}/active-fish-group";

export const CageController_AllCages = (
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<CageListItemDto[]>> => {
  return Http.getRequest(
    CageController_AllCages.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
CageController_AllCages.key = "/api/v2/cage/all";

/**
 *
 * Configuration and data-availability context for a single cage
 */
export const CageController_Context = (
  cageId: number,
  queryParams?: CageController_ContextQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<CageContextResponseDto>> => {
  return Http.getRequest(
    template(CageController_Context.key, { cageId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
CageController_Context.key = "/api/v2/cage/{cageId}/context";

export const CageController_FishTypes = (
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<FishType[]>> => {
  return Http.getRequest(
    CageController_FishTypes.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
CageController_FishTypes.key = "/api/v2/cage/fish-types";

export const CageController_LiceTypes = (
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<LiceType[]>> => {
  return Http.getRequest(
    CageController_LiceTypes.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
CageController_LiceTypes.key = "/api/v2/cage/lice-types";

export const CageController_LocationTypes = (
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<LocationTypeInfo[]>> => {
  return Http.getRequest(
    CageController_LocationTypes.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
CageController_LocationTypes.key = "/api/v2/cage/location-types";

/**
 *
 * Biomass, bioscope, behaviour and environmental overview for a single cage
 */
export const CageController_Overview = (
  cageId: number,
  queryParams?: CageController_OverviewQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<BiomassOverviewResponseDto>> => {
  return Http.getRequest(
    template(CageController_Overview.key, { cageId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
CageController_Overview.key = "/api/v2/cage/{cageId}/overview";

export const CageController_Status = (
  cageId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<CageStatus>> => {
  return Http.getRequest(
    template(CageController_Status.key, { cageId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
CageController_Status.key = "/api/v2/cage/{cageId}/last-measurement";

/**
 *
 * Create multiple cages for a location in one transaction
 */
export const CageController_createManyCages = (
  requestBody: CreateCagesDto,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    CageController_createManyCages.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
CageController_createManyCages.key = "/api/v2/cage/bulk";

export const CageController_deleteCage = (
  cageId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(CageController_deleteCage.key, { cageId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
CageController_deleteCage.key = "/api/v2/cage/{cageId}";

export const CageController_getCageTypes = (
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<GetCageTypesResponse>> => {
  return Http.getRequest(
    CageController_getCageTypes.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
CageController_getCageTypes.key = "/api/v2/cage/cage-types";

export const CageController_getCageWinch = (
  cageId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<{ [x in string | number]: any }>> => {
  return Http.getRequest(
    template(CageController_getCageWinch.key, { cageId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
CageController_getCageWinch.key = "/api/v2/cage/{cageId}/winch";

/**
 *
 * Health summary for a single cage (Cage Dashboard)
 */
export const CageController_getHealthOverview = (
  cageId: number,
  queryParams?: CageController_getHealthOverviewQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<CageHealthOverviewResponseDto>> => {
  return Http.getRequest(
    template(CageController_getHealthOverview.key, { cageId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
CageController_getHealthOverview.key = "/api/v2/cage/{cageId}/health-overview";

export const CageController_getWeightDistributions = (
  cageId: number,
  queryParams?: CageController_getWeightDistributionsQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<GetWeightDistributionsResponse>> => {
  return Http.getRequest(
    template(CageController_getWeightDistributions.key, { cageId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
CageController_getWeightDistributions.key =
  "/api/v2/cage/{cageId}/distributions";

/**
 *
 * Welfare and swim-speed summary for a single cage
 */
export const CageController_getWelfareOverview = (
  cageId: number,
  queryParams?: CageController_getWelfareOverviewQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<CageWelfareOverviewResponseDto>> => {
  return Http.getRequest(
    template(CageController_getWelfareOverview.key, { cageId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
CageController_getWelfareOverview.key =
  "/api/v2/cage/{cageId}/welfare-overview";

export const CageController_updateCage = (
  cageId: number,
  requestBody: UpdateCageDto,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<UpdateCageResponse>> => {
  return Http.patchRequest(
    template(CageController_updateCage.key, { cageId }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
CageController_updateCage.key = "/api/v2/cage/{cageId}";

/**
 *
 * Average depth for one pen
 */
export const CageDepthSeriesController_getCageDepthSeries = (
  cageId: number,
  queryParams: CageDepthSeriesController_getCageDepthSeriesQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<DepthSeriesResponseDto>> => {
  return Http.getRequest(
    template(CageDepthSeriesController_getCageDepthSeries.key, { cageId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
CageDepthSeriesController_getCageDepthSeries.key =
  "/api/v2/cage/{cageId}/depth-series";

/**
 *
 * Days that have bioscope inspection images for a cage
 */
export const CageImageController_GetDaysWithImages = (
  cageId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<DaysWithImages[]>> => {
  return Http.getRequest(
    template(CageImageController_GetDaysWithImages.key, { cageId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
CageImageController_GetDaysWithImages.key =
  "/api/v2/cage/{cageId}/images/bioscope/days";

/**
 *
 * Bioscope inspection images for a single day (defaults to latest)
 */
export const CageImageController_GetImageList = (
  cageId: number,
  queryParams?: CageImageController_GetImageListQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<CageImage[]>> => {
  return Http.getRequest(
    template(CageImageController_GetImageList.key, { cageId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
CageImageController_GetImageList.key = "/api/v2/cage/{cageId}/images/bioscope";

export const CageImageController_Image = (
  cageId: number,
  id: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    template(CageImageController_Image.key, { cageId, id }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
CageImageController_Image.key = "/api/v2/cage/{cageId}/images/bioscope/{id}";

export const ClientController_AllLiceDailyReport = (
  clientId: number,
  queryParams: ClientController_AllLiceDailyReportQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<DailyReportResult>> => {
  return Http.getRequest(
    template(ClientController_AllLiceDailyReport.key, { clientId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ClientController_AllLiceDailyReport.key =
  "/api/v2/client/internal/{clientId}/lice/dailyReport";

export const ClientController_AllLiceDailyReports = (
  clientId: number,
  queryParams: ClientController_AllLiceDailyReportsQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<DailyClientReportResult>> => {
  return Http.getRequest(
    template(ClientController_AllLiceDailyReports.key, { clientId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ClientController_AllLiceDailyReports.key =
  "/api/v2/client/internal/{clientId}/lice/dailyReports";

/**
 *
 * Every stored weekly lice report for the client, plus the running week
 */
export const ClientController_AllLiceWeeklyReport = (
  clientId: number,
  queryParams?: ClientController_AllLiceWeeklyReportQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<AllWeeklyReportResponseDto>> => {
  return Http.getRequest(
    template(ClientController_AllLiceWeeklyReport.key, { clientId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ClientController_AllLiceWeeklyReport.key =
  "/api/v2/client/internal/{clientId}/lice/allWeeklyReport";

export const ClientController_CreateNewClient = (
  requestBody: CreateNewClientInput,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<CreatedClientDto>> => {
  return Http.putRequest(
    ClientController_CreateNewClient.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ClientController_CreateNewClient.key =
  "/api/v2/client/internal/createNewClient";

export const ClientController_GetAllClientsWithLocations = (
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ClientWithLocationsInfo[]>> => {
  return Http.getRequest(
    ClientController_GetAllClientsWithLocations.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ClientController_GetAllClientsWithLocations.key =
  "/api/v2/client/internal/clientsWithLocations";

/**
 *
 * Every client with counts and recency signals, for the internal clients table
 */
export const ClientController_GetClientSummaries = (
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ClientSummaryDto[]>> => {
  return Http.getRequest(
    ClientController_GetClientSummaries.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ClientController_GetClientSummaries.key = "/api/v2/client/internal/summaries";

export const ClientController_GetClientWithLocations = (
  clientId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ClientWithLocationsInfo>> => {
  return Http.getRequest(
    template(ClientController_GetClientWithLocations.key, { clientId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ClientController_GetClientWithLocations.key =
  "/api/v2/client/internal/{clientId}/clientWithLocations";

export const ClientController_GetClients = (
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ClientInfo[]>> => {
  return Http.getRequest(
    ClientController_GetClients.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ClientController_GetClients.key = "/api/v2/client/internal";

export const ClientController_Overview = (
  clientId: number,
  queryParams?: ClientController_OverviewQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ClientOverviewResponseDto>> => {
  return Http.getRequest(
    template(ClientController_Overview.key, { clientId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ClientController_Overview.key = "/api/v2/client/internal/{clientId}/overview";

export const ClientController_RangeLiceReport = (
  clientId: number,
  queryParams: ClientController_RangeLiceReportQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<RangeReportResult>> => {
  return Http.getRequest(
    template(ClientController_RangeLiceReport.key, { clientId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ClientController_RangeLiceReport.key =
  "/api/v2/client/internal/{clientId}/lice/rangeReport";

export const ClientController_RangeLiceReports = (
  clientId: number,
  queryParams: ClientController_RangeLiceReportsQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<RangeClientReportResult>> => {
  return Http.getRequest(
    template(ClientController_RangeLiceReports.key, { clientId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ClientController_RangeLiceReports.key =
  "/api/v2/client/internal/{clientId}/lice/rangeReports";

export const ClientController_createApiUser = (
  clientId: number,
  requestBody: CreateApiUserInput,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(ClientController_createApiUser.key, { clientId }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ClientController_createApiUser.key =
  "/api/v2/client/internal/{clientId}/apiUsers";

export const ClientController_getApiUsers = (
  clientId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<GetApiUsersResponse[]>> => {
  return Http.getRequest(
    template(ClientController_getApiUsers.key, { clientId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ClientController_getApiUsers.key =
  "/api/v2/client/internal/{clientId}/apiUsers";

export const ClientController_getClientVideoStreamSettings = (
  clientId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<BioscopeStreamSettingsRowDto[]>> => {
  return Http.getRequest(
    template(ClientController_getClientVideoStreamSettings.key, { clientId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ClientController_getClientVideoStreamSettings.key =
  "/api/v2/client/internal/{clientId}/video-stream-settings";

export const ClientController_updateBioscopeVideoStreamSettings = (
  clientId: number,
  bioscopeId: number,
  requestBody: UpdateVideoStreamSettingsInput,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<VideoStreamSettingsDto>> => {
  return Http.putRequest(
    template(ClientController_updateBioscopeVideoStreamSettings.key, {
      clientId,
      bioscopeId,
    }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ClientController_updateBioscopeVideoStreamSettings.key =
  "/api/v2/client/internal/{clientId}/bioscope/{bioscopeId}/video-stream-settings";

export const ClientController_updateClient = (
  clientId: number,
  requestBody: UpdateClientDto,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ClientInfo>> => {
  return Http.patchRequest(
    template(ClientController_updateClient.key, { clientId }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ClientController_updateClient.key = "/api/v2/client/internal/{clientId}";

export const ClientController_updateLocationVideoStreamSettings = (
  clientId: number,
  locationId: number,
  requestBody: UpdateVideoStreamSettingsInput,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<VideoStreamSettingsDto[]>> => {
  return Http.putRequest(
    template(ClientController_updateLocationVideoStreamSettings.key, {
      clientId,
      locationId,
    }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ClientController_updateLocationVideoStreamSettings.key =
  "/api/v2/client/internal/{clientId}/location/{locationId}/video-stream-settings";

/**
 *
 * Get compare data for all cages at a location
 */
export const CompareController_getLocationCompare = (
  clientId: number,
  locationId: number,
  queryParams?: CompareController_getLocationCompareQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<LocationCompareResponseDto>> => {
  return Http.getRequest(
    template(CompareController_getLocationCompare.key, {
      clientId,
      locationId,
    }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
CompareController_getLocationCompare.key =
  "/api/v2/client/internal/{clientId}/location/{locationId}/compare";

/**
 *
 * Get all notices and banner messages
 */
export const ContentController_getSanityContent = (
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<SanityContentResponse>> => {
  return Http.getRequest(
    ContentController_getSanityContent.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ContentController_getSanityContent.key = "/api/v2/content/notices";

/**
 *
 * Mint or rotate a device API key
 */
export const DeviceKeyController_CreateApiKey = (
  /**
   *
   * Registered device_type.name: bioscope, winch, router, server, …
   */
  deviceType: string,
  /**
   *
   * Public device id
   */
  deviceId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(DeviceKeyController_CreateApiKey.key, { deviceType, deviceId }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
DeviceKeyController_CreateApiKey.key =
  "/api/v2/devices/{deviceType}/{deviceId}/apikey";

export const FeedbackController_ImageFeedback = (
  requestBody: ImageFeedbackDto,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    FeedbackController_ImageFeedback.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
FeedbackController_ImageFeedback.key = "/api/v2/feedback/image";

/**
 *
 * Get site feeding dashboard configuration
 */
export const FeedingDashboardController_getConfig = (
  /**
   *
   * Location (site) ID
   */
  locationId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<FeedingDashboardConfigDto>> => {
  return Http.getRequest(
    template(FeedingDashboardController_getConfig.key, { locationId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
FeedingDashboardController_getConfig.key =
  "/api/v2/feeding-dashboard/{locationId}/config";

/**
 *
 * Feeding performance dashboard overview for a site
 */
export const FeedingDashboardController_getOverview = (
  /**
   *
   * Location (site) ID
   */
  locationId: number,
  queryParams?: FeedingDashboardController_getOverviewQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<FeedingDashboardOverviewDto>> => {
  return Http.getRequest(
    template(FeedingDashboardController_getOverview.key, { locationId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
FeedingDashboardController_getOverview.key =
  "/api/v2/feeding-dashboard/{locationId}";

/**
 *
 * Override the site configuration for one pen
 */
export const FeedingDashboardController_updateCageConfig = (
  /**
   *
   * Location (site) ID
   */
  locationId: number,
  /**
   *
   * Pen (cage) ID
   */
  cageId: number,
  requestBody: UpdateFeedingCageConfigDto,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<FeedingDashboardConfigDto>> => {
  return Http.putRequest(
    template(FeedingDashboardController_updateCageConfig.key, {
      locationId,
      cageId,
    }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
FeedingDashboardController_updateCageConfig.key =
  "/api/v2/feeding-dashboard/{locationId}/pens/{cageId}/config";

/**
 *
 * Update site feeding dashboard configuration
 */
export const FeedingDashboardController_updateConfig = (
  /**
   *
   * Location (site) ID
   */
  locationId: number,
  requestBody: UpdateFeedingDashboardConfigDto,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<FeedingDashboardConfigDto>> => {
  return Http.putRequest(
    template(FeedingDashboardController_updateConfig.key, { locationId }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
FeedingDashboardController_updateConfig.key =
  "/api/v2/feeding-dashboard/{locationId}/config";

/**
 *
 * Close a fish group independently (harvest, decommission, operational close)
 */
export const FishGroupsController_close = (
  clientId: number,
  fishGroupId: number,
  requestBody: CloseFishGroupRequest,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(FishGroupsController_close.key, { clientId, fishGroupId }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
FishGroupsController_close.key =
  "/api/v2/fish-groups/{clientId}/{fishGroupId}/close";

/**
 *
 * Create a new fish group (initial placement, no DAG lineage). Internal tooling; customers use POST :clientId/locations/:locationId/fish-groups. stockingCycleId is required unless the caller is an Optoscale admin.
 */
export const FishGroupsController_create = (
  clientId: number,
  requestBody: CreateFishGroupRequest,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(FishGroupsController_create.key, { clientId }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
FishGroupsController_create.key = "/api/v2/fish-groups/{clientId}/create";

/**
 *
 * Discard a fish group created by mistake (only valid before any DAG activity — no transfers as source or destination)
 */
export const FishGroupsController_discard = (
  clientId: number,
  fishGroupId: number,
  requestBody: DiscardFishGroupRequest,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(FishGroupsController_discard.key, { clientId, fishGroupId }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
FishGroupsController_discard.key =
  "/api/v2/fish-groups/{clientId}/{fishGroupId}/discard";

/**
 *
 * Timeline of a single cage: every fish group that has lived in this cage, ordered chronologically from earliest to most recent. Excludes soft-deleted (discard) entries.
 */
export const FishGroupsController_getCageHistory = (
  clientId: number,
  cageId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<CageFishGroupHistoryItemDto[]>> => {
  return Http.getRequest(
    template(FishGroupsController_getCageHistory.key, { clientId, cageId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
FishGroupsController_getCageHistory.key =
  "/api/v2/fish-groups/{clientId}/cages/{cageId}/history";

/**
 *
 * Detail of a single fish group with its current location (cage + parent location) resolved
 */
export const FishGroupsController_getDetail = (
  clientId: number,
  fishGroupId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<FishGroupDetailDto>> => {
  return Http.getRequest(
    template(FishGroupsController_getDetail.key, { clientId, fishGroupId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
FishGroupsController_getDetail.key =
  "/api/v2/fish-groups/{clientId}/{fishGroupId}";

/**
 *
 * Event history of a fish group (lifecycle + manual events) ordered most-recent-first
 */
export const FishGroupsController_getEvents = (
  clientId: number,
  fishGroupId: number,
  queryParams?: FishGroupsController_getEventsQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<FishGroupTransferEventDto[]>> => {
  return Http.getRequest(
    template(FishGroupsController_getEvents.key, { clientId, fishGroupId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
FishGroupsController_getEvents.key =
  "/api/v2/fish-groups/{clientId}/{fishGroupId}/events";

/**
 *
 * Lineage of a fish group: ancestors + descendants via closure table, returned as flat lists and as a graph (nodes + edges)
 */
export const FishGroupsController_getLineage = (
  clientId: number,
  fishGroupId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<FishGroupLineageDto>> => {
  return Http.getRequest(
    template(FishGroupsController_getLineage.key, { clientId, fishGroupId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
FishGroupsController_getLineage.key =
  "/api/v2/fish-groups/{clientId}/{fishGroupId}/lineage";

/**
 *
 * Full location history of a fish group, ordered from earliest to most recent. Excludes soft-deleted (discard) entries.
 */
export const FishGroupsController_getLocations = (
  clientId: number,
  fishGroupId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<FishGroupLocationHistoryItemDto[]>> => {
  return Http.getRequest(
    template(FishGroupsController_getLocations.key, { clientId, fishGroupId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
FishGroupsController_getLocations.key =
  "/api/v2/fish-groups/{clientId}/{fishGroupId}/locations";

/**
 *
 * Tabular overview of a client: every location with its non-historical cages and the active fish group on each cage
 */
export const FishGroupsController_getOverview = (
  clientId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ClientFishGroupsOverviewDto>> => {
  return Http.getRequest(
    template(FishGroupsController_getOverview.key, { clientId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
FishGroupsController_getOverview.key =
  "/api/v2/fish-groups/{clientId}/overview";

/**
 *
 * What reverting an operation would do (groups restored and discarded, manual events left on discarded groups) and what blocks it, without changing anything
 */
export const FishGroupsController_getRevertPreview = (
  clientId: number,
  operationId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<RevertPreviewDto>> => {
  return Http.getRequest(
    template(FishGroupsController_getRevertPreview.key, {
      clientId,
      operationId,
    }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
FishGroupsController_getRevertPreview.key =
  "/api/v2/fish-groups/{clientId}/operations/{operationId}/revert-preview";

/**
 *
 * Execute a composition-changing operation (split, merge, or split-and-merge)
 */
export const FishGroupsController_operate = (
  clientId: number,
  requestBody: FishGroupOperationRequest,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(FishGroupsController_operate.key, { clientId }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
FishGroupsController_operate.key = "/api/v2/fish-groups/{clientId}/operate";

/**
 *
 * Record a standalone non-lifecycle event on an active fish group (mortality, partial harvest, measurement, feeding, treatment)
 */
export const FishGroupsController_recordEvent = (
  clientId: number,
  fishGroupId: number,
  requestBody: RecordFishGroupEventRequest,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(FishGroupsController_recordEvent.key, { clientId, fishGroupId }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
FishGroupsController_recordEvent.key =
  "/api/v2/fish-groups/{clientId}/{fishGroupId}/event";

/**
 *
 * Relocate a fish group to a different empty cage (identity-preserving)
 */
export const FishGroupsController_relocate = (
  clientId: number,
  fishGroupId: number,
  requestBody: RelocateFishGroupRequest,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(FishGroupsController_relocate.key, { clientId, fishGroupId }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
FishGroupsController_relocate.key =
  "/api/v2/fish-groups/{clientId}/{fishGroupId}/relocate";

/**
 *
 * Revert (annul) an operation recorded by mistake: discard the groups it created and restore the groups it closed in the stay it closed. Bioscopes are not moved.
 */
export const FishGroupsController_revertOperation = (
  clientId: number,
  operationId: number,
  requestBody: RevertFishGroupOperationRequest,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(FishGroupsController_revertOperation.key, {
      clientId,
      operationId,
    }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
FishGroupsController_revertOperation.key =
  "/api/v2/fish-groups/{clientId}/operations/{operationId}/revert";

/**
 *
 * Correct fish group metadata (name, notes, initial population size). Allowed on any status, including closed groups — a correction is a record fix, not a lifecycle event. Every change is journalled as a metadata_updated event.
 */
export const FishGroupsController_updateMetadata = (
  clientId: number,
  fishGroupId: number,
  requestBody: UpdateFishGroupMetadataRequest,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<FishGroupDto>> => {
  return Http.patchRequest(
    template(FishGroupsController_updateMetadata.key, {
      clientId,
      fishGroupId,
    }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
FishGroupsController_updateMetadata.key =
  "/api/v2/fish-groups/{clientId}/{fishGroupId}/metadata";

/**
 *
 * Get health overview data for a cage
 */
export const HealthController_getHealthData = (
  /**
   *
   * Cage ID
   */
  cageId: number,
  queryParams?: HealthController_getHealthDataQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<HealthOverviewDto>> => {
  return Http.getRequest(
    template(HealthController_getHealthData.key, { cageId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
HealthController_getHealthData.key = "/api/v2/health/{cageId}";

/**
 *
 * Quality (estimated downgrade) for a cage
 */
export const HealthController_getQuality = (
  /**
   *
   * Cage ID
   */
  cageId: number,
  queryParams?: HealthController_getQualityQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<HealthQualityResponseDto>> => {
  return Http.getRequest(
    template(HealthController_getQuality.key, { cageId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
HealthController_getQuality.key = "/api/v2/health/{cageId}/quality";

/**
 *
 * Daily lice counts for a cage (three-day rolling average)
 */
export const LiceController_DailyLice = (
  cageId: number,
  queryParams: LiceController_DailyLiceQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<DailyLiceCountResponseDto>> => {
  return Http.getRequest(
    template(LiceController_DailyLice.key, { cageId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LiceController_DailyLice.key = "/api/v2/lice/{cageId}/lice/daily";

/**
 *
 * Sea temperature series for a cage, plotted alongside lice counts
 */
export const LiceController_GetTemperature = (
  cageId: number,
  queryParams: LiceController_GetTemperatureQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<TemperatureResult[]>> => {
  return Http.getRequest(
    template(LiceController_GetTemperature.key, { cageId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LiceController_GetTemperature.key = "/api/v2/lice/{cageId}/temperature";

/**
 *
 * Latest three-day lice averages, with the week-on-week change
 */
export const LiceController_Last200Lice = (
  cageId: number,
  queryParams?: LiceController_Last200LiceQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<Last3DaysResponseDto>> => {
  return Http.getRequest(
    template(LiceController_Last200Lice.key, { cageId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LiceController_Last200Lice.key = "/api/v2/lice/{cageId}/lice/last200";

/**
 *
 * Compare the sql and core lice implementations for a cage
 */
export const LiceController_LiceParity = (
  cageId: number,
  queryParams: LiceController_LiceParityQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<{ [x in string | number]: any }>> => {
  return Http.getRequest(
    template(LiceController_LiceParity.key, { cageId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LiceController_LiceParity.key = "/api/v2/lice/{cageId}/lice/parity";

/**
 *
 * Weekly lice counts for a cage
 */
export const LiceController_WeeklyLice = (
  cageId: number,
  queryParams: LiceController_WeeklyLiceQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<WeeklyLiceCountResponseDto>> => {
  return Http.getRequest(
    template(LiceController_WeeklyLice.key, { cageId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LiceController_WeeklyLice.key = "/api/v2/lice/{cageId}/lice/weekly";

export const LicenseController_addContractLicense = (
  id: number,
  requestBody: CreateNewContractLicenseInput,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ContractLicenseRecord>> => {
  return Http.putRequest(
    template(LicenseController_addContractLicense.key, { id }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LicenseController_addContractLicense.key =
  "/api/v2/licenses/contract/{id}/license";

export const LicenseController_archiveContract = (
  id: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ContractRecord>> => {
  return Http.patchRequest(
    template(LicenseController_archiveContract.key, { id }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LicenseController_archiveContract.key =
  "/api/v2/licenses/contract/{id}/archive";

export const LicenseController_createContract = (
  requestBody: CreateNewContractInput,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ContractRecord>> => {
  return Http.putRequest(
    LicenseController_createContract.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LicenseController_createContract.key = "/api/v2/licenses/contract";

/**
 * @deprecated This endpoint deprecated and will be remove. Please use an alternative
 */
export const LicenseController_createNewLicenseForClient = (
  requestBody: CreateNewLicenseForClientInput,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  if (__DEV__) {
    console.warn(
      "LicenseController_createNewLicenseForClient",
      "This endpoint deprecated and will be remove. Please use an alternative",
    );
  }
  return Http.postRequest(
    LicenseController_createNewLicenseForClient.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LicenseController_createNewLicenseForClient.key = "/api/v2/licenses/client";

/**
 * @deprecated This endpoint deprecated and will be remove. Please use an alternative
 */
export const LicenseController_deleteClientLicenses = (
  id: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ClientLicenseResponse>> => {
  if (__DEV__) {
    console.warn(
      "LicenseController_deleteClientLicenses",
      "This endpoint deprecated and will be remove. Please use an alternative",
    );
  }
  return Http.deleteRequest(
    template(LicenseController_deleteClientLicenses.key, { id }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LicenseController_deleteClientLicenses.key = "/api/v2/licenses/client/{id}";

export const LicenseController_deleteContractLicense = (
  contractId: number,
  licenseId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ContractLicenseRecord>> => {
  return Http.deleteRequest(
    template(LicenseController_deleteContractLicense.key, {
      contractId,
      licenseId,
    }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LicenseController_deleteContractLicense.key =
  "/api/v2/licenses/contract/{contractId}/license/{licenseId}";

/**
 * @deprecated This endpoint deprecated and will be remove. Please use an alternative
 */
export const LicenseController_getAllClientUser = (
  clientId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ClientLicenseUser[]>> => {
  if (__DEV__) {
    console.warn(
      "LicenseController_getAllClientUser",
      "This endpoint deprecated and will be remove. Please use an alternative",
    );
  }
  return Http.getRequest(
    template(LicenseController_getAllClientUser.key, { clientId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LicenseController_getAllClientUser.key = "/api/v2/licenses/users/{clientId}";

/**
 * @deprecated This endpoint deprecated and will be remove. Please use an alternative
 */
export const LicenseController_getAllClientWithUser = (
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ClientWithLocations[]>> => {
  if (__DEV__) {
    console.warn(
      "LicenseController_getAllClientWithUser",
      "This endpoint deprecated and will be remove. Please use an alternative",
    );
  }
  return Http.getRequest(
    LicenseController_getAllClientWithUser.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LicenseController_getAllClientWithUser.key = "/api/v2/licenses/clients";

/**
 * @deprecated This endpoint deprecated and will be remove. Please use an alternative
 */
export const LicenseController_getAllUser = (
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<LicenseUser[]>> => {
  if (__DEV__) {
    console.warn(
      "LicenseController_getAllUser",
      "This endpoint deprecated and will be remove. Please use an alternative",
    );
  }
  return Http.getRequest(
    LicenseController_getAllUser.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LicenseController_getAllUser.key = "/api/v2/licenses/users";

export const LicenseController_getClientContracts = (
  clientId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<Contract[]>> => {
  return Http.getRequest(
    template(LicenseController_getClientContracts.key, { clientId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LicenseController_getClientContracts.key =
  "/api/v2/licenses/client/{clientId}/contracts";

/**
 * @deprecated This endpoint deprecated and will be remove. Please use an alternative
 */
export const LicenseController_getClientLicenses = (
  clientId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<LicenseResponse[]>> => {
  if (__DEV__) {
    console.warn(
      "LicenseController_getClientLicenses",
      "This endpoint deprecated and will be remove. Please use an alternative",
    );
  }
  return Http.getRequest(
    template(LicenseController_getClientLicenses.key, { clientId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LicenseController_getClientLicenses.key = "/api/v2/licenses/client/{clientId}";

export const LicenseController_getLicense = (
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<LicenseInfo[]>> => {
  return Http.getRequest(
    LicenseController_getLicense.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LicenseController_getLicense.key = "/api/v2/licenses/license";

export const LicenseController_getLocationsLicense = (
  clientId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<LocationsLicenseOverview[]>> => {
  return Http.getRequest(
    template(LicenseController_getLocationsLicense.key, { clientId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LicenseController_getLocationsLicense.key =
  "/api/v2/licenses/{clientId}/locations/licenses";

export const LicenseController_unarchiveContract = (
  id: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ContractRecord>> => {
  return Http.patchRequest(
    template(LicenseController_unarchiveContract.key, { id }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LicenseController_unarchiveContract.key =
  "/api/v2/licenses/contract/{id}/unarchive";

/**
 * @deprecated This endpoint deprecated and will be remove. Please use an alternative
 */
export const LicenseController_updateClientLicense = (
  id: number,
  requestBody: UpdateClientLicenseInput,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ClientLicenseResponse>> => {
  if (__DEV__) {
    console.warn(
      "LicenseController_updateClientLicense",
      "This endpoint deprecated and will be remove. Please use an alternative",
    );
  }
  return Http.patchRequest(
    template(LicenseController_updateClientLicense.key, { id }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LicenseController_updateClientLicense.key = "/api/v2/licenses/client/{id}";

export const LicenseController_updateContract = (
  id: number,
  requestBody: CreateNewContractInput,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ContractRecord>> => {
  return Http.patchRequest(
    template(LicenseController_updateContract.key, { id }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LicenseController_updateContract.key = "/api/v2/licenses/contract/{id}";

export const LicenseController_updateContractLicense = (
  contractId: number,
  licenseId: number,
  requestBody: CreateNewContractLicenseInput,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ContractLicenseRecord>> => {
  return Http.patchRequest(
    template(LicenseController_updateContractLicense.key, {
      contractId,
      licenseId,
    }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LicenseController_updateContractLicense.key =
  "/api/v2/licenses/contract/{contractId}/license/{licenseId}";

export const LocationController_CreateLocation = (
  requestBody: NewLocation,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<LocationResponseDto>> => {
  return Http.putRequest(
    LocationController_CreateLocation.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LocationController_CreateLocation.key = "/api/v2/location";

export const LocationController_DeleteLocation = (
  locationId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<LocationResponseDto>> => {
  return Http.deleteRequest(
    template(LocationController_DeleteLocation.key, { locationId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LocationController_DeleteLocation.key = "/api/v2/location/{locationId}";

export const LocationController_LocationBioscopeStatus = (
  locationId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<LocationBioscopeStatusDto>> => {
  return Http.getRequest(
    template(LocationController_LocationBioscopeStatus.key, { locationId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LocationController_LocationBioscopeStatus.key =
  "/api/v2/location/{locationId}/bioscopeStatus";

export const LocationController_LocationWeightStatus = (
  locationId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<LocationWeightStatusDto>> => {
  return Http.getRequest(
    template(LocationController_LocationWeightStatus.key, { locationId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LocationController_LocationWeightStatus.key =
  "/api/v2/location/{locationId}/weightStatus";

export const LocationController_MarkHistorical = (
  cageId: number,
  queryParams: LocationController_MarkHistoricalQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<CageHistoricalDto>> => {
  return Http.putRequest(
    template(LocationController_MarkHistorical.key, { cageId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LocationController_MarkHistorical.key =
  "/api/v2/location/cages/{cageId}/markHistorical";

export const LocationController_UpdateLocation = (
  locationId: number,
  requestBody: UpdateLocation,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<LocationResponseDto>> => {
  return Http.patchRequest(
    template(LocationController_UpdateLocation.key, { locationId }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LocationController_UpdateLocation.key = "/api/v2/location/{locationId}";

/**
 *
 * Average depth for every pen at a location
 */
export const LocationDepthSeriesController_getLocationDepthSeries = (
  clientId: number,
  locationId: number,
  queryParams: LocationDepthSeriesController_getLocationDepthSeriesQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<DepthSeriesResponseDto>> => {
  return Http.getRequest(
    template(LocationDepthSeriesController_getLocationDepthSeries.key, {
      clientId,
      locationId,
    }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LocationDepthSeriesController_getLocationDepthSeries.key =
  "/api/v2/client/internal/{clientId}/location/{locationId}/depth-series";

/**
 *
 * Create a fish group in an empty pen of this site. stockingCycleId (a planned or active cycle of the site) is required unless the caller is an Optoscale admin; species defaults to salmon; the start may be at most one month in the past.
 */
export const LocationFishGroupsController_create = (
  clientId: number,
  locationId: number,
  requestBody: CreateFishGroupRequest,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(LocationFishGroupsController_create.key, { clientId, locationId }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LocationFishGroupsController_create.key =
  "/api/v2/fish-groups/{clientId}/locations/{locationId}/fish-groups";

/**
 *
 * The site's pens that hold an open stay, in any cycle or none, a stocking registered for a later date included: the pens a new fish group can't go into.
 */
export const LocationFishGroupsController_occupiedPens = (
  clientId: number,
  locationId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<OccupiedPensDto>> => {
  return Http.getRequest(
    template(LocationFishGroupsController_occupiedPens.key, {
      clientId,
      locationId,
    }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LocationFishGroupsController_occupiedPens.key =
  "/api/v2/fish-groups/{clientId}/locations/{locationId}/occupied-pens";

/**
 *
 * The site board: the cycle header and every fish group in scope (active and closed, not discarded) with its pen stays, bioscope coverage, events and lineage edges, in one call. Scope: ?stockingCycleId=<id>|unassigned, else the from/to date window (default: the last 180 days).
 */
export const LocationFishGroupsController_timeline = (
  clientId: number,
  locationId: number,
  queryParams?: LocationFishGroupsController_timelineQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<FishGroupTimelineDto>> => {
  return Http.getRequest(
    template(LocationFishGroupsController_timeline.key, {
      clientId,
      locationId,
    }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
LocationFishGroupsController_timeline.key =
  "/api/v2/fish-groups/{clientId}/locations/{locationId}/timeline";

export const MoveBioscopeController_DeleteLastMove = (
  bioscopeId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(MoveBioscopeController_DeleteLastMove.key, { bioscopeId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
MoveBioscopeController_DeleteLastMove.key =
  "/api/v2/bioscopes/move/{bioscopeId}";

export const MoveBioscopeController_MoveBioscope = (
  bioscopeId: number,
  requestBody: MoveBioscopeQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(MoveBioscopeController_MoveBioscope.key, { bioscopeId }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
MoveBioscopeController_MoveBioscope.key = "/api/v2/bioscopes/move/{bioscopeId}";

/**
 *
 * Generate EMQX JWT token
 */
export const MqttJwtController_generateEmqxToken = (
  requestBody: EmqxJwtPayloadDto,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    MqttJwtController_generateEmqxToken.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
MqttJwtController_generateEmqxToken.key =
  "/api/v2/mqtt-jwt/generate-token-emqx";

/**
 *
 * Resolve a numeric id as a cage, bioscope, and/or winch
 */
export const NavigationController_resolveById = (
  id: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<NavigationResolveResponseDto>> => {
  return Http.getRequest(
    template(NavigationController_resolveById.key, { id }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
NavigationController_resolveById.key = "/api/v2/navigation/{id}";

/**
 *
 * Search cages by location and pen name
 */
export const NavigationController_searchByName = (
  queryParams: NavigationController_searchByNameQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<NavigationResolveResponseDto>> => {
  return Http.getRequest(
    NavigationController_searchByName.key,
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
NavigationController_searchByName.key = "/api/v2/navigation/search";

export const PenOverviewController_getPenOverview = (
  locationId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<PenOverviewResponseDto>> => {
  return Http.getRequest(
    template(PenOverviewController_getPenOverview.key, { locationId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
PenOverviewController_getPenOverview.key =
  "/api/v2/operational-dashboard/{locationId}/pen-overview";

/**
 *
 * Provider accounts: rows that belong to no pen
 */
export const ProviderAccountsController_getAccounts = (
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ProviderAccountDto[]>> => {
  return Http.getRequest(
    ProviderAccountsController_getAccounts.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ProviderAccountsController_getAccounts.key = "/api/v2/provider-config/accounts";

/**
 *
 * A client's provider rows, pen by pen
 */
export const ProviderAccountsController_getClientIntegrations = (
  /**
   *
   * Client ID
   */
  clientId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ClientIntegrationRowDto[]>> => {
  return Http.getRequest(
    template(ProviderAccountsController_getClientIntegrations.key, {
      clientId,
    }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ProviderAccountsController_getClientIntegrations.key =
  "/api/v2/provider-config/client/{clientId}/integrations";

/**
 *
 * Create or update one provider's account row
 */
export const ProviderAccountsController_saveAccount = (
  /**
   *
   * An account provider
   */
  providerName: string,
  requestBody: SaveProviderAccountRequestDto,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ProviderAccountDto[]>> => {
  return Http.putRequest(
    template(ProviderAccountsController_saveAccount.key, { providerName }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ProviderAccountsController_saveAccount.key =
  "/api/v2/provider-config/accounts/{providerName}";

/**
 *
 * Re-fetch a pen's daily feeding data for a window
 */
export const ProviderConfigActionsController_fetchHistory = (
  /**
   *
   * Location (site) ID
   */
  locationId: number,
  /**
   *
   * Cage (pen) ID
   */
  cageId: number,
  requestBody: FetchHistoryRequestDto,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<FetchHistoryResultDto>> => {
  return Http.postRequest(
    template(ProviderConfigActionsController_fetchHistory.key, {
      locationId,
      cageId,
    }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ProviderConfigActionsController_fetchHistory.key =
  "/api/v2/provider-config/location/{locationId}/pens/{cageId}/fetch-history";

/**
 *
 * List the site's Clarify items for the pen mapping picker
 */
export const ProviderConfigActionsController_listClarifyCatalog = (
  /**
   *
   * Location (site) ID
   */
  locationId: number,
  requestBody: ClarifyCatalogRequestDto,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ClarifyCatalogDto>> => {
  return Http.postRequest(
    template(ProviderConfigActionsController_listClarifyCatalog.key, {
      locationId,
    }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ProviderConfigActionsController_listClarifyCatalog.key =
  "/api/v2/provider-config/location/{locationId}/clarify/catalog";

/**
 *
 * Test one provider's unsaved config at a site
 */
export const ProviderConfigActionsController_testProviderConfig = (
  /**
   *
   * Location (site) ID
   */
  locationId: number,
  providerName: string,
  requestBody: TestProviderConfigRequestDto,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<TestProviderConfigResultDto>> => {
  return Http.postRequest(
    template(ProviderConfigActionsController_testProviderConfig.key, {
      locationId,
      providerName,
    }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ProviderConfigActionsController_testProviderConfig.key =
  "/api/v2/provider-config/location/{locationId}/{providerName}/test";

/**
 *
 * A site's provider config, grouped by provider
 */
export const ProviderConfigController_getLocationConfig = (
  /**
   *
   * Location (site) ID
   */
  locationId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<LocationProviderConfigDto>> => {
  return Http.getRequest(
    template(ProviderConfigController_getLocationConfig.key, { locationId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ProviderConfigController_getLocationConfig.key =
  "/api/v2/provider-config/location/{locationId}";

/**
 *
 * Schemas of the feeding providers the portal can configure
 */
export const ProviderConfigController_getProviderSchemas = (
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ProviderSchemaDto[]>> => {
  return Http.getRequest(
    ProviderConfigController_getProviderSchemas.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ProviderConfigController_getProviderSchemas.key =
  "/api/v2/provider-config/providers";

/**
 *
 * Save one provider's config at a site
 */
export const ProviderConfigController_saveProviderConfig = (
  /**
   *
   * Location (site) ID
   */
  locationId: number,
  providerName: string,
  requestBody: SaveProviderConfigRequestDto,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<LocationProviderConfigDto>> => {
  return Http.putRequest(
    template(ProviderConfigController_saveProviderConfig.key, {
      locationId,
      providerName,
    }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ProviderConfigController_saveProviderConfig.key =
  "/api/v2/provider-config/location/{locationId}/{providerName}";

export const ReportsController_CreateReport = (
  cageId: number,
  requestBody: NewReport,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(ReportsController_CreateReport.key, { cageId }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ReportsController_CreateReport.key = "/api/v2/reports/{cageId}";

export const ReportsController_DeleteReport = (
  cageId: number,
  reportId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(ReportsController_DeleteReport.key, { cageId, reportId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ReportsController_DeleteReport.key = "/api/v2/reports/{cageId}/{reportId}";

export const ReportsController_Report = (
  cageId: number,
  reportId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ReportDetail>> => {
  return Http.getRequest(
    template(ReportsController_Report.key, { cageId, reportId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ReportsController_Report.key = "/api/v2/reports/{cageId}/{reportId}";

export const ReportsController_ReportList = (
  cageId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<ReportList[]>> => {
  return Http.getRequest(
    template(ReportsController_ReportList.key, { cageId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
ReportsController_ReportList.key = "/api/v2/reports/{cageId}";

/**
 *
 * Split one fish group into several pens (reason "grading" for a grading) or merge several into one pen, at this site. Every result must inherit a stocking cycle unless the caller is an Optoscale admin.
 */
export const SiteFishGroupActionsController_operate = (
  clientId: number,
  locationId: number,
  requestBody: FishGroupOperationRequest,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(SiteFishGroupActionsController_operate.key, {
      clientId,
      locationId,
    }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
SiteFishGroupActionsController_operate.key =
  "/api/v2/fish-groups/{clientId}/locations/{locationId}/operations";

/**
 *
 * Register a delousing of a whole fish group at this site.
 */
export const SiteFishGroupActionsController_recordDelousing = (
  clientId: number,
  locationId: number,
  fishGroupId: number,
  requestBody: SiteDelousingRequest,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(SiteFishGroupActionsController_recordDelousing.key, {
      clientId,
      locationId,
      fishGroupId,
    }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
SiteFishGroupActionsController_recordDelousing.key =
  "/api/v2/fish-groups/{clientId}/locations/{locationId}/fish-groups/{fishGroupId}/delousing";

/**
 *
 * Move a whole fish group to an empty pen of this site, optionally with its bioscopes and a delousing on the same date.
 */
export const SiteFishGroupActionsController_relocate = (
  clientId: number,
  locationId: number,
  fishGroupId: number,
  requestBody: SiteRelocateFishGroupRequest,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(SiteFishGroupActionsController_relocate.key, {
      clientId,
      locationId,
      fishGroupId,
    }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
SiteFishGroupActionsController_relocate.key =
  "/api/v2/fish-groups/{clientId}/locations/{locationId}/fish-groups/{fishGroupId}/relocate";

/**
 *
 * Add fish groups of this site to one of its stockings, each with its whole lineage component. Refused when the component leaves the site or the client, or is partly in another stocking. Every changed group gets a metadata_updated event.
 */
export const SiteStockingAssignmentController_assign = (
  clientId: number,
  locationId: number,
  stockingCycleId: number,
  requestBody: SiteStockingAssignmentRequest,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<AssignFishGroupsToCycleResponseDto>> => {
  return Http.postRequest(
    template(SiteStockingAssignmentController_assign.key, {
      clientId,
      locationId,
      stockingCycleId,
    }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
SiteStockingAssignmentController_assign.key =
  "/api/v2/fish-groups/{clientId}/locations/{locationId}/stocking-cycles/{stockingCycleId}/fish-groups";

/**
 *
 * The groups that move with this one when its stocking changes (its lineage component), the stockings they are in, and why a site manager can't change it, if so.
 */
export const SiteStockingAssignmentController_previewLineage = (
  clientId: number,
  locationId: number,
  fishGroupId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<StockingLineageDto>> => {
  return Http.getRequest(
    template(SiteStockingAssignmentController_previewLineage.key, {
      clientId,
      locationId,
      fishGroupId,
    }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
SiteStockingAssignmentController_previewLineage.key =
  "/api/v2/fish-groups/{clientId}/locations/{locationId}/fish-groups/{fishGroupId}/stocking-lineage";

/**
 *
 * Take fish groups of this site out of a stocking, each with its whole lineage component, back to no stocking. Every changed group gets a metadata_updated event.
 */
export const SiteStockingAssignmentController_unassign = (
  clientId: number,
  locationId: number,
  stockingCycleId: number,
  requestBody: SiteStockingAssignmentRequest,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<UnassignFishGroupsFromCycleResponseDto>> => {
  return Http.postRequest(
    template(SiteStockingAssignmentController_unassign.key, {
      clientId,
      locationId,
      stockingCycleId,
    }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
SiteStockingAssignmentController_unassign.key =
  "/api/v2/fish-groups/{clientId}/locations/{locationId}/stocking-cycles/{stockingCycleId}/fish-groups/unassign";

export const SmoltReportController_createReport = (
  cageId: number,
  requestBody: CreateSmoltReportDto,
  queryParams?: SmoltReportController_createReportQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(SmoltReportController_createReport.key, { cageId }),
    queryParams,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
SmoltReportController_createReport.key = "/api/v2/smolt-reports/{cageId}";

export const SmoltReportController_deleteReport = (
  cageId: number,
  reportId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(SmoltReportController_deleteReport.key, { cageId, reportId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
SmoltReportController_deleteReport.key =
  "/api/v2/smolt-reports/{cageId}/{reportId}";

export const SmoltReportController_getReportDetail = (
  cageId: number,
  reportId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<SmoltReportDetailResponseDto>> => {
  return Http.getRequest(
    template(SmoltReportController_getReportDetail.key, { cageId, reportId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
SmoltReportController_getReportDetail.key =
  "/api/v2/smolt-reports/{cageId}/{reportId}";

export const SmoltReportController_listReports = (
  cageId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<SmoltReportListResponseDto[]>> => {
  return Http.getRequest(
    template(SmoltReportController_listReports.key, { cageId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
SmoltReportController_listReports.key = "/api/v2/smolt-reports/{cageId}";

export const SmsController_SmsWebhook = (
  requestBody: SmsInput,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    SmsController_SmsWebhook.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
SmsController_SmsWebhook.key = "/api/sms";

/**
 *
 * Assign fish groups to a stocking cycle. Each group's whole lineage component moves with it, and every changed group gets a metadata_updated event. Use ?dryRun=true to preview the cascade and warnings.
 */
export const StockingCyclesController_assignFishGroups = (
  clientId: number,
  stockingCycleId: number,
  requestBody: AssignFishGroupsToCycleRequest,
  queryParams?: StockingCyclesController_assignFishGroupsQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<AssignFishGroupsToCycleResponseDto>> => {
  return Http.postRequest(
    template(StockingCyclesController_assignFishGroups.key, {
      clientId,
      stockingCycleId,
    }),
    queryParams,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
StockingCyclesController_assignFishGroups.key =
  "/api/v2/fish-groups/{clientId}/stocking-cycles/{stockingCycleId}/fish-groups";

/**
 *
 * Create a stocking cycle at a site. The name defaults to the season convention (e.g. 26A) when omitted.
 */
export const StockingCyclesController_create = (
  clientId: number,
  locationId: number,
  requestBody: CreateStockingCycleRequest,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(StockingCyclesController_create.key, { clientId, locationId }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
StockingCyclesController_create.key =
  "/api/v2/fish-groups/{clientId}/locations/{locationId}/stocking-cycles";

/**
 *
 * Stocking cycles of a site, newest first, with derived status, stocking window and fallowing, plus the unassigned group count and a suggested name for a new cycle
 */
export const StockingCyclesController_list = (
  clientId: number,
  locationId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<StockingCycleListDto>> => {
  return Http.getRequest(
    template(StockingCyclesController_list.key, { clientId, locationId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
StockingCyclesController_list.key =
  "/api/v2/fish-groups/{clientId}/locations/{locationId}/stocking-cycles";

/**
 *
 * Update the name, planned start date or notes of a stocking cycle
 */
export const StockingCyclesController_update = (
  clientId: number,
  stockingCycleId: number,
  requestBody: UpdateStockingCycleRequest,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<StockingCycleDto>> => {
  return Http.patchRequest(
    template(StockingCyclesController_update.key, {
      clientId,
      stockingCycleId,
    }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
StockingCyclesController_update.key =
  "/api/v2/fish-groups/{clientId}/stocking-cycles/{stockingCycleId}";

/**
 *
 * Edit a stocking cycle of this site from the board: its name, planned start date or notes. Status and stocked weeks stay derived from the groups.
 */
export const StockingCyclesController_updateAtSite = (
  clientId: number,
  locationId: number,
  stockingCycleId: number,
  requestBody: UpdateStockingCycleRequest,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<StockingCycleDto>> => {
  return Http.patchRequest(
    template(StockingCyclesController_updateAtSite.key, {
      clientId,
      locationId,
      stockingCycleId,
    }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
StockingCyclesController_updateAtSite.key =
  "/api/v2/fish-groups/{clientId}/locations/{locationId}/stocking-cycles/{stockingCycleId}";

export const TasksController_completeTask = (
  taskId: number,
  requestBody: CompleteTaskDto,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<TaskResponseDto>> => {
  return Http.patchRequest(
    template(TasksController_completeTask.key, { taskId }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
TasksController_completeTask.key =
  "/api/v2/operational-dashboard/tasks/{taskId}/complete";

export const TasksController_getTasks = (
  locationId: number,
  queryParams?: TasksController_getTasksQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<TaskListResponseDto>> => {
  return Http.getRequest(
    template(TasksController_getTasks.key, { locationId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
TasksController_getTasks.key =
  "/api/v2/operational-dashboard/{locationId}/tasks";

export const TasksController_ignoreTask = (
  taskId: number,
  requestBody: IgnoreTaskDto,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<TaskResponseDto>> => {
  return Http.patchRequest(
    template(TasksController_ignoreTask.key, { taskId }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
TasksController_ignoreTask.key =
  "/api/v2/operational-dashboard/tasks/{taskId}/ignore";

export const TasksController_unignoreTask = (
  taskId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<TaskResponseDto>> => {
  return Http.patchRequest(
    template(TasksController_unignoreTask.key, { taskId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
TasksController_unignoreTask.key =
  "/api/v2/operational-dashboard/tasks/{taskId}/unignore";

/**
 *
 * Delete a user
 */
export const UserController_DeleteUser = (
  userId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<DeleteUserResponse>> => {
  return Http.deleteRequest(
    template(UserController_DeleteUser.key, { userId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
UserController_DeleteUser.key = "/api/v2/user/{userId}";

export const UserController_EndImpersonate = (
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    UserController_EndImpersonate.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
UserController_EndImpersonate.key = "/api/v2/user/end-impersonate";

export const UserController_ImpersonateUser = (
  userId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(UserController_ImpersonateUser.key, { userId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
UserController_ImpersonateUser.key = "/api/v2/user/impersonate/{userId}";

export const UserController_InviteUser = (
  requestBody: InviteForm,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    UserController_InviteUser.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
UserController_InviteUser.key = "/api/v2/user/invite";

export const UserController_Login = (
  requestBody: LoginForm,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    UserController_Login.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
UserController_Login.key = "/api/v2/user/login";

export const UserController_Logout = (
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    UserController_Logout.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
UserController_Logout.key = "/api/v2/user/logout";

export const UserController_Me = (
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<Me>> => {
  return Http.getRequest(
    UserController_Me.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
UserController_Me.key = "/api/v2/user/me";

export const UserController_RegisterUser = (
  requestBody: RegisterUserForm,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    UserController_RegisterUser.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
UserController_RegisterUser.key = "/api/v2/user/register";

export const UserController_ResetPassword = (
  requestBody: ResetPassword,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    UserController_ResetPassword.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
UserController_ResetPassword.key = "/api/v2/user/reset-password";

export const UserController_ResetPasswordRequest = (
  requestBody: ResetPasswordRequest,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    UserController_ResetPasswordRequest.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
UserController_ResetPasswordRequest.key = "/api/v2/user/reset-password-request";

export const UserController_SetUserClientAccess = (
  userId: number,
  requestBody: SetUserClientAccessForm,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<{ [x in string | number]: any }>> => {
  return Http.putRequest(
    template(UserController_SetUserClientAccess.key, { userId }),
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
UserController_SetUserClientAccess.key = "/api/v2/user/{userId}/client-access";

export const UserController_UpdateProfile = (
  requestBody: UpdateUserProfileDto,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<UserProfileDto>> => {
  return Http.patchRequest(
    UserController_UpdateProfile.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
UserController_UpdateProfile.key = "/api/v2/user/profile";

/**
 *
 * Forcefully disable stream
 */
export const VideoStreamController_disableBioscopeStream = (
  bioscopeId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(VideoStreamController_disableBioscopeStream.key, { bioscopeId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
VideoStreamController_disableBioscopeStream.key =
  "/api/v2/video-stream/bioscope/{bioscopeId}/disable-stream";

/**
 *
 * Get daily streaming quota exceeded info
 */
export const VideoStreamController_getBioscopeQuotaCheck = (
  bioscopeId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(VideoStreamController_getBioscopeQuotaCheck.key, { bioscopeId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
VideoStreamController_getBioscopeQuotaCheck.key =
  "/api/v2/video-stream/bioscope/{bioscopeId}/quota-check";

/**
 *
 * Get streams status for location
 */
export const VideoStreamController_getLocationStreamsStatus = (
  locationId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<LocationStreamStatusDto[]>> => {
  return Http.getRequest(
    template(VideoStreamController_getLocationStreamsStatus.key, {
      locationId,
    }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
VideoStreamController_getLocationStreamsStatus.key =
  "/api/v2/video-stream/location/{locationId}/status";

/**
 *
 * Start a new stream or join existing stream
 */
export const VideoStreamController_startStream = (
  bioscopeId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(VideoStreamController_startStream.key, { bioscopeId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
VideoStreamController_startStream.key =
  "/api/v2/video-stream/bioscope/{bioscopeId}/start";

/**
 *
 * Stop streaming or leave stream
 */
export const VideoStreamController_stopStream = (
  bioscopeId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(VideoStreamController_stopStream.key, { bioscopeId }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
VideoStreamController_stopStream.key =
  "/api/v2/video-stream/bioscope/{bioscopeId}/stop";

/**
 *
 * Handle Mux webhook notifications
 */
export const VideoStreamWebhookNewController_handleMuxWebhook = (
  headerParams?: { "mux-signature": string },
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<{ [x in string | number]: any }>> => {
  return Http.postRequest(
    VideoStreamWebhookNewController_handleMuxWebhook.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(
      {
        headers: {
          ..._CONSTANT3,
          ...headerParams,
        },
      },
      configOverride,
    ),
  );
};

/** Key is end point string without base url */
VideoStreamWebhookNewController_handleMuxWebhook.key =
  "/api/v2/video-stream/webhooks/mux";

export const WelfareController_GetFullSizeImage = (
  cageId: number,
  id: string,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    template(WelfareController_GetFullSizeImage.key, { cageId, id }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
WelfareController_GetFullSizeImage.key = "/api/v2/welfare/{cageId}/images/{id}";

/**
 *
 * A pen's welfare or lice images of one type, newest first
 */
export const WelfareController_allImages = (
  cageId: number,
  queryParams?: WelfareController_allImagesQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<FullSizeImage[]>> => {
  return Http.getRequest(
    template(WelfareController_allImages.key, { cageId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
WelfareController_allImages.key = "/api/v2/welfare/{cageId}/allImages";

/**
 *
 * Black-and-white welfare for a Bioscope 1.0 cage, or a fish group seen through it
 */
export const WelfareController_getFullWelfare = (
  cageId: number,
  queryParams: WelfareController_getFullWelfareQueryParams,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<BwWelfareResponse>> => {
  return Http.getRequest(
    template(WelfareController_getFullWelfare.key, { cageId }),
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
WelfareController_getFullWelfare.key = "/api/v2/welfare/{cageId}/full-welfare";

export const WinchController_CreateApiKey = (
  winchId: number,
  configOverride?: AxiosRequestConfig,
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(WinchController_CreateApiKey.key, { winchId }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride),
  );
};

/** Key is end point string without base url */
WinchController_CreateApiKey.key = "/api/v2/winch/{winchId}/apikey";
export const _CONSTANT0 = {
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
};
export const _CONSTANT1 = [{ "production-api-key": [] }];
export const _CONSTANT2 = {
  headers: {
    "Content-Type": "application/json",
    Accept: "text/csv",
  },
};
export const _CONSTANT3 = {
  "Content-Type": "application/json",
  Accept: "application/json",
};
